import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProcessCapacityService = {

    async saveShift(payload) {
        const url = "api/Save_Shift";
        return await ApiService.post(url, payload);
    },

    async getShiftByCode(shiftCode) {
        const requestScreenData = {
            url: `api/Shift`,
            filter: `Code eq '${shiftCode}'`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getShiftByRecordId(recordId) {
        const requestScreenData = {
            url: `api/Shift`,
            filter: `RecordID eq ${recordId}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getShiftExceptionByRecordId(recordId) {
        const requestScreenData = {
            url: `api/ShiftException`,
            filter: `RecordID eq ${recordId}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getProcessShiftExceptionByRecordId(recordId) {
        const requestScreenData = {
            url: `api/ProcessShiftException`,
            filter: `RecordID eq ${recordId}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },


    dataSourceConfig(url, params) {
        return ApiService.createDataSource(url, params);
    },

    async getShiftDownTime(ShiftRecordID) {
        const requestScreenData = {
            url: `api/ShiftDownTime`,
            filter: `ShiftRecordID eq ${ShiftRecordID}`,
            orderby: "StartTime asc",
        };
        return await ApiService.oDataGet(requestScreenData);
    },

    async getExceptionDownTime(exceptionType, exceptionRecordId, shiftRecordId, processRecordId, startDate) {
        let url = `/api/ExceptionDownTime`;
        url += `?type=${exceptionType}`;
        url += `&exceptionRecordId=${exceptionRecordId}`;
        url += `&shiftRecordId=${shiftRecordId}`;
        url += `&processRecordId=${processRecordId}`;
        url += `&startDate=${startDate}`;
        return await ApiService.get(url);
    },

    async getShiftExceptionDownTime(shiftExceptionRecordId) {
        const requestScreenData = {
            url: `api/ShiftExceptionDownTime`,
            filter: `ShiftExceptionRecordID eq ${shiftExceptionRecordId}`,
            orderby: "StartTime asc",
        };
        return await ApiService.oDataGet(requestScreenData);
    },

    async getProcessShiftRecurring(shiftRecordID) {
        const requestScreenData = {
            url: `api/ProcessShiftRecurring`,
            filter: `ShiftRecordID eq ${shiftRecordID}`,
            expand: "ProcessShiftRecurringDownTimes",
        };
        return await ApiService.oDataGet(requestScreenData);
    },

    async getProcessShiftRecurringDownTime(ShiftRecordID, ProcessCode) {
        const requestScreenData = {
            url: `api/ProcessShiftRecurringDownTime`,
            filter: `ShiftRecordID eq ${ShiftRecordID} and ProcessCode eq '${ProcessCode}'`,
            orderby: "StartTime asc",
        };
        return await ApiService.oDataGet(requestScreenData);
    },

    async getProcessShiftExceptionDownTime(ProcessShiftExceptionRecordID) {
        const requestScreenData = {
            url: `api/ProcessShiftExceptionDownTime`,
            filter: `ProcessShiftExceptionRecordID eq ${ProcessShiftExceptionRecordID}`,
            orderby: "Name asc",
        };
        return await ApiService.oDataGet(requestScreenData);
    },

    async saveShiftException(payload) {
        const url = "api/Save_ShiftException";
        return await ApiService.post(url, payload);
    },

    async saveSaveProcessShiftException(payload) {
        const url = "api/Save_ProcessShiftException";
        return await ApiService.post(url, payload);
    },

    async deleteProcessShiftException(recordId) {
        const url = "api/ProcessShiftException";
        return await ApiService.delete(url,recordId,"Guid");
    },

    async deleteShiftException(recordId) {
        const url = "api/ShiftException";
        return await ApiService.delete(url,recordId,"Guid");
    },
}

export { ProcessCapacityService };